import React, {useState, useEffect} from "react";
import styled from "styled-components";

import closeIcon from '../images/closeIcon.svg'

export default function ModalControllerReport(props) {
  const [textoComQuebraDeLinha, setTextoComQuebraDeLinha] = useState("");
  const date = new Date(props?.modalReportData?.createdAt).toLocaleString('pt-br')
  const dateFinally = date.split(',')
  useEffect(() => {
    const description = props?.modalReportData?.report?.split('.');
    const descriptionFinally = description?.join(".<br>");
    setTextoComQuebraDeLinha(descriptionFinally)
  }, [props])
  
  if (props.modalReportState) {
    return (
      <Container>
        <Img src={closeIcon} onClick={() => {
          props.setModalReportState(false)
          props.setClicked('')
        }} />

        <Main>
          <ContentMain>
          <LabelTitle>Author</LabelTitle>
            <Text>{props.modalReportData.author}</Text>
            <LabelTitle>Data</LabelTitle>
            <Text>{dateFinally[0]}</Text>
            <LabelTitle>Extração</LabelTitle>
            <Text>{props.modalReportData.extractionId}</Text>
            <LabelTitle>Report</LabelTitle>
            <Text dangerouslySetInnerHTML={{__html: textoComQuebraDeLinha}} id="description"></Text>
          </ContentMain>
        </Main>
      </Container>
    )
  }


}

const Container = styled.div`  
  width: 35vw;
  max-width: 455px;
  height: 90vh;
  background-color: #333333;

  margin: auto 2vw auto 0;

  border-radius: 20px;

  position: relative;

  @media (max-width: 1300px) {
    max-width: 300px;
  }

`

const Img = styled.img`
  width: 30px;
  height: 30px;

  position: absolute;
  right: 15px;
  top: 15px;

  cursor: pointer;
`

const Main = styled.div`
  margin: 15px;
  margin-top: 60px;  
  height: 80%;
  overflow-y: auto;
  overflow-x: hidden;
  &::-webkit-scrollbar {
    width: 7px;
  }

  &::-webkit-scrollbar-track {
    background: #333333;
  }

  &::-webkit-scrollbar-thumb {
    background-color: #242424;
    border-radius: 12px;
  }

`

const ContentMain = styled.div`
  text-align: justify;
  margin: 10px;
`

const Title = styled.h1`
  margin-top: 0;

  font-family: 'HelveticaNowforMonksExtraBold', sans-serif;
  font-size: 1.3rem;
  word-break: break-word;

  color: #F6BE27;

  @media(max-width: 1500px) {
    font-size: 1.0rem;
  }
`
const LabelTitle = styled.div`
  font-family: "HelveticaNowforMonksExtraBold";
  width: 100%;
  display: flex;
  justify-content: center;
  font-size: 16px;
  color: #ffffff;
  cursor: pointer;
  margin-top: 10px;
`;
const Text = styled.p`
  text-align: justify;
  font-family: 'Space Grotesk';
  font-style: normal;
  font-weight: 700;
  font-size: 18px;
  color: #F6BE27;
  word-break: break-all;
  @media (max-width: 1300px){
    font-size: 15px;
  }
`